<template>
    <div class="container">
            <section class="app-todo">
                <div class="">
                    <input autofocus class="form-control todo-input"
                     type="text" placeholder="what needs to be done ?" 
                     v-model="newtodo" @keyup.enter="addtodo" >
                </div>
                <div class="todo-header d-flex text-center">
                    <div  class="check-all">
                       
                        <label>
                            <input type="checkbox" :checked="!anyRemaining"
                             @change="check_all_tasks"  >
                            <span> Check All</span>
                        </label>
                    </div>
                    <h5 >Tasks:</h5>
                </div>
                <hr>
                <ul class="todo-list" v-for="(task, index) in FiltredTasks" :key="index">
                    <li class="todo ">
                       <div class=" todo-list d-flex align-items-center">
                            <input class="checkbox-item mx-2"  type="checkbox" v-model="task.complited" > 
                            <div class="todo-item-left">
                                <label v-if="!task.editing" class="todo-item-label" :class="{complited : task.complited}"  @dblclick="edit_todo(task)">{{task.title}}</label>
                                <input  v-else class="todo-item-edit mx-2"  type="text" v-model="task.title" @blur="doneEdit(task)" @keyup.enter="doneEdit(task)" v-task-focus="task == task" @keyup.esc="cancelEdit(task)">
                            </div>
                            <span class="remove-task mx-2" @click="removetodo(index)">&times;</span>
                       </div>
                    </li>
                    <hr>
                </ul>
            </section>
            <hr>
            <footer class="footer d-flex justify-content-between align-items-center text-center p-2" >
                <span>
                    <strong> {{remaining}} items left</strong>
                </span>
                <ul class="filter d-flex align-items-center">
                    
                </ul>
                <div class="filter">
                    <span>Filter: </span>
                     <button 
                      :class="{active : filter == 'all'}"
                      @click="filter = 'all'">All</button>
                     <button  
                     :class="{active: filter == 'active'}"
                     @click="filter = 'active'">Active</button>
                     <button 
                      :class="{active : filter == 'complited'}"
                      @click="filter = 'complited'">complited</button>
                </div>
                <button @click="deleteAllComplited" v-if="showDeletebtn" class="clear-completed btn btn-danger">
                    Clear completed
                </button>
            </footer>
            <hr>
            <footer class="info">
			<p>Double-click to edit a todo</p>
			<p>Written by <a href="http://salimtahayacine.github.io/">Stronglover</a></p>
		</footer>
    </div>
</template>

<script>

    export default {
        directives:{
            focus: {
                inserted: function (el) {    
                    el.focus()
                }
            },
            'task-focus': function (el, binding) {
				if (binding.value) {
					el.focus();
				}
			},
        },
        setup(){
        },
        data() {
            return {
                newtodo:'',
                beforEditCache: '',
                filter : 'all',
                dynamicId:4,
                Tasks:[
                    {id:1,title:'Wake up early this week',complited:false,editing:false},
                    {id:2,title:'do 100 push-up in a day ',complited:false,editing:false},
                    {id:3,title:'dont miss your prayer',complited:false,editing:false},
                ],
                
            }
        },
        computed:{
            remaining (){
                return this.Tasks.filter(task => !task.complited).length
            },
            anyRemaining(){
                // return this.Tasks.filter(task => task.complited)
                return this.remaining != 0 ;
            },FiltredTasks(){
                if(this.filter == 'all'){
                    return this.Tasks;
                }else if(this.filter == 'active'){
                    return this.Tasks.filter( (task) => task.complited==false)
                }
                else if(this.filter == 'complited'){
                    return this.Tasks.filter( (task) => task.complited==true)
                }
                return this.Tasks;
            },showDeletebtn(){
                return this.Tasks.filter( (task) => task.complited==true).length > 0
            }
        },
        methods:{
            addtodo(){
                if(this.newtodo.trim().length == 0){
                     return
                    }
                this.Tasks.push(
                    {
                        id : this.dynamicId++,
                        title : this.newtodo,
                        complited: false
                    }
                );
                    this.newtodo = '';
            },
            removetodo(index){
                this.Tasks.splice(index, 1)
            },
            edit_todo(task){
                this.beforEditCache = task.title
                task.editing = true;
            
            },
            doneEdit(task){
                if(task.title.trim() == ''){
                    task.title = this.beforEditCache
                }
                task.editing = false;
            },
            cancelEdit(task) {
                task.title = this.beforEditCache
                task.editing = false
            },
            check_all_tasks() {
                this.Tasks.forEach( (task) => task.complited = event.target.checked)
            },
            deleteAllComplited(){
                this.Tasks = this.Tasks.filter( (task) => !task.complited)
            }
        }
    }
</script>

<style lang="scss" scoped>
.todo-header{
 justify-content: space-between;
}
.todo-header input{
  margin-left: 39px ;
}
.todo-header h5{
  margin-right: 355px ;
}
.todo-input{
 padding: 10px 20px;
 font-size: 20px;
 margin-bottom: 16px;
 
}
.remove-task{
    cursor: pointer;
    margin-left: 14px;
    font-size: 28px;
    &:hover{
        color: red;
    }
}
.app-todo input::-webkit-input-placeholder {
	font-style: italic;
	font-weight: 300;
	color: #e6e6e6;
}
.check-all{
    margin-left: 40px;
    cursor: pointer;
}

.filter button{
    font-size: 15px;
    border-radius: 4px;
    padding: 0px 12px;
    margin: 0px 8px;
    &:hover{
        background-color: #eee;
        color: #333;
    }
    &:focus{
        outline: none;
    }
}
.active{
    color: #666;
    background-color:#99ff99;}
.container{
    background: #eee;
    padding: 20px;
    border-radius: 8px;
    max-width: 800px;
}
.todo-list {
    align-items: center;
    justify-content: space-around;
}
.todo-item-label{
    justify-content: start;
    padding: 8px;
    border: 1px solid white;
    width: 100%;
}
.todo-item-edit{
    justify-content: start;
    font-size: 24px;
    // margin-left: 12px;
    padding: 10px;
    width: 100%;
    border : 1px solid #ccc;
    font-family: 'Avenir',Arial, Helvetica, sans-serif;
}
.complited{
 text-decoration: line-through;
 color:deeppink;
}

ul,li{
    list-style: none;
}
a{
    text-decoration: none;
}
</style>